<template>
  <div class="Reports__View">
    <EntityListLayout :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>בנק ספרים</template>
      <template #button>
        <a @click="addBookToBank" class="link-button">
          ספר חדש
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import AdminService from "@/services/AdminService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import DialogAddBookToBank from '@/components/DialogAddBookToBank.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";
import BookBankEntity from "./BookBankEntity.vue";

export default {
  name: "AdminSearchReports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const reportsFields = FieldService.list("books");
      const sideViewEntity = {
        component: BookBankEntity,
        preview: true,
        readOnly: false,
        title: "פרטי ספר",
        recordTitle: 'הצג ספר',
        hideRecord: true,
        recordUrl: "bookBank",
      };
      const fields = [
        { ...reportsFields.Id, checked: true },
        { ...reportsFields.Title, checked: true },
        { ...reportsFields.Subtitle, checked: true },
        { ...reportsFields.Author, checked: true },
        { ...reportsFields.Link, checked: true },
        { ...reportsFields.Status, checked: true },
      ];

      this.tabs = [
        {
          id: "AllBooksAdmin",
          title: "כל הספרים",
          getDataAsync: this.getAllBooks,
          perPage: 100,
          fields,
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: false,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש ספר",
          },
          sideViewEntity,
          tableActions: null,
          isAdminArea: true,
          defaultQuery: false
        },
      ];
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getAllBooks({ cancelToken, ...rest }) {
      return AdminService.getBooksInBank(
        {
          ...rest,
          IsAscending: false
        },
        cancelToken.token
      ).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
    addBookToBank() {
      Modal.open({
        component: DialogAddBookToBank,
        props: {
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    }
  },
  watch: {
  },
};
</script>
<style lang="scss" scoped>
.Reports__View {
  height: 100%;

  .link-button {
    background: #00427e;
    border: none;
    border-radius: 3px;
    padding: 14px 25px;
    margin-left: 10px;
    color: white;
    cursor: pointer;
  }
}
</style>
